const types = {
  inheritance: 'Affidavit of Heirship',
  trust: 'Appointment/Removal of Trustee',
  foreclosure: 'Pre-Foreclosure',
  probates: 'Probate'
}
export default types
